import React, { HTMLProps } from "react";
import { useIsMobile } from "../../../../../Responsive";
import { IonItem } from "@ionic/react";

export const Wrapper = (props: HTMLProps<HTMLDivElement>) =>
{
    const mobileView = useIsMobile();

    return mobileView ? <React.Fragment>{props.children}</React.Fragment> : <div {...props} />;
};

export const Item = (props: any) =>
{
    const mobileView = useIsMobile();

    return mobileView ? <React.Fragment>{props.children}</React.Fragment> : <IonItem {...props} />;
};

export const MobileContainer = (props: HTMLProps<HTMLDivElement>) =>
{
    const mobileView = useIsMobile();
    return !mobileView ? <React.Fragment>{props.children}</React.Fragment> : <div {...props} />;
};